import {GetAnalysisExecution} from 'analysis-tool/AnalysisTypes';

import {
  AnalysisGraphNode,
  AnalysisGraphNodeData,
  AnalysisGraphNodeType,
  AnalysisGraphEdge,
  AnalysisGraphEdgeType,
  AnalysisGraph,
  DraftAnalysisGraphEdgeData,
} from './AnalysisGraphTypes';
import AnalysisGraphUtils from './AnalysisGraphUtils';

function createNodes(analysisExecution: GetAnalysisExecution, isTemplate: boolean): Array<AnalysisGraphNode> {
  return analysisExecution.steps
    .map((step) => ({
      step,
      isTemplate,
      targetHandleIds: step.inputStepDatas.map((stepData) => AnalysisGraphUtils.getHandleId(stepData.name)),
      sourceHandleIds: step.outputStepDatas.map((stepData) => AnalysisGraphUtils.getHandleId(stepData.name)),
    }))
    .map((nodeData: AnalysisGraphNodeData) => ({
      id: AnalysisGraphUtils.getNodeId(nodeData),
      data: nodeData,
      position: {x: 0, y: 0},
      type: AnalysisGraphNodeType.STEP,
    }));
}

function createEdges(analysisExecution: GetAnalysisExecution): Array<AnalysisGraphEdge> {
  return analysisExecution.steps
    .flatMap((parentStep) =>
      parentStep.definition.outgoingEdges.map((outgoingEdge) => ({
        parent: parentStep,
        parentStepDataName: outgoingEdge.parentStepData.name,
        child: analysisExecution.steps.find((step) => step.id === outgoingEdge.child.step.id)!,
        childStepDataName: outgoingEdge.childStepData.name,
      }))
    )
    .map((draftEdgeData: DraftAnalysisGraphEdgeData) => ({
      id: AnalysisGraphUtils.getEdgeId(draftEdgeData),
      data: AnalysisGraphUtils.getEdgeData(draftEdgeData),
      source: AnalysisGraphUtils.getNodeId({step: draftEdgeData.parent}),
      target: AnalysisGraphUtils.getNodeId({step: draftEdgeData.child}),
      sourceHandle: AnalysisGraphUtils.getHandleId(draftEdgeData.parentStepDataName),
      targetHandle: AnalysisGraphUtils.getHandleId(draftEdgeData.childStepDataName),
      type: AnalysisGraphEdgeType.EDGE,
    }));
}

/**
 * Create the flowchart graph of an analysis
 */
export default function createAnalysisGraph(
  analysisExecution: GetAnalysisExecution,
  isTemplate?: boolean
): AnalysisGraph {
  const nodes = createNodes(analysisExecution, isTemplate || false);
  const edges = createEdges(analysisExecution);

  return {nodes, edges};
}
